import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  HiOutlineVideoCamera,
  HiOutlineSpeakerphone,
  HiOutlinePencilAlt,
  HiOutlineMicrophone,
} from "react-icons/hi";

const FEATURES = [
  {
    icon: HiOutlineVideoCamera,
    title: "Sign Language to Text",
    description:
      "Record or stream sign language gestures and receive real-time text translations. Perfect for enabling written communication.",
  },
  {
    icon: HiOutlineSpeakerphone,
    title: "Sign Language to Speech",
    description:
      "Get spoken translations of sign language. Ideal for face-to-face conversations where hearing partners need audio.",
  },
  {
    icon: HiOutlinePencilAlt,
    title: "Text to Sign Language",
    description:
      "Type and watch our 3D avatar translate your words into sign language, making your message accessible to deaf individuals.",
  },
  {
    icon: HiOutlineMicrophone,
    title: "Speech to Sign Language",
    description:
      "Speak naturally and see your words translated into sign language through our animated 3D avatar in real-time.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-[#f4f4f4] dark:bg-[#181818] py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-[#053676] dark:text-[#2A71E8] font-sans font-bold text-3xl sm:text-4xl mb-4">
            How It Works
          </h2>
          <p className="text-[#09062C] dark:text-gray-300 font-sans font-medium text-lg max-w-2xl mx-auto">
            Four powerful translation modes to bridge communication gaps
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
          {FEATURES.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.12 }}
                className="bg-white dark:bg-black rounded-[20px] p-6 sm:p-8 aboutUsShadow hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#BE2117] to-[#053676] flex items-center justify-center mb-5">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-[#053676] dark:text-[#2A71E8] font-sans font-bold text-xl mb-3">
                  {feature.title}
                </h3>
                <p className="text-[#09062C] dark:text-gray-300 font-sans font-medium text-[15px] leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center mt-12"
        >
          <Link
            to="/register"
            className="inline-block bg-[#2A71E8] text-white font-sans font-bold px-10 py-3 rounded-[20px] text-lg hover:bg-[#1e5bb5] transition-colors"
          >
            Try It Now
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
